import { actionTypes } from '~/src/features/full-buy/store';
import { TSubscription } from '~/src/features/full-buy/store/initialState';

export const setBundleOfSubscriptions = (subscriptionsBundle: Record<number, { oneOf: number[], items: TSubscription[] }>) => ({
    type: actionTypes.SetBundleOfSubscriptions,
    payload: {
        bundle: subscriptionsBundle,
    },
});
